import { Component, Inject, OnInit } from "@angular/core"; // Import Inject, OnInit, remove Input, OnChanges, SimpleChanges
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog"; // Import dialog related modules
import {
  TokenContractAssignment,
  TokenDetail,
} from "../../../../interfaces/responses/models";
import { WalletService } from "../../../../services/payment/wallet.service";

@Component({
  selector: "app-token-details",
  templateUrl: "./token-details.component.html",
  styleUrls: ["./token-details.component.scss"],
})
export class TokenDetailsComponent implements OnInit {
  // Implement OnInit instead of OnChanges
  // Remove @Input decorators
  userId: number | null = null;
  bidRoundId: string | null = null;

  tokenContracts: TokenContractAssignment[] = [];
  tokenContractsLoading: boolean = false;
  tokenContractsError: string | null = null;

  tokenDetails: TokenDetail[] = [];
  tokenDetailsLoading: boolean = false;
  tokenDetailsError: string | null = null;

  constructor(
    private walletService: WalletService,
    public dialogRef: MatDialogRef<TokenDetailsComponent>, // Inject MatDialogRef
    @Inject(MAT_DIALOG_DATA)
    public data: { userId: number | null; bidRoundId: string | null } // Inject MAT_DIALOG_DATA
  ) {
    // Assign data from injection
    this.userId = data.userId;
    this.bidRoundId = data.bidRoundId;
  }

  ngOnInit(): void {
    // Use ngOnInit
    if (this.userId !== null) {
      // Check if userId is available
      this.getTokenDetails();
      this.getTokenContracts();
    }
  }

  formatNumber(value: number | string): string {
    const numValue = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(numValue)) {
      return "₹0.00";
    }
    return `₹${numValue.toFixed(2)}`;
  }

  getTokenDetails(): void {
    if (this.userId === null) return;

    this.tokenDetailsLoading = true;
    this.tokenDetailsError = null;

    const bidRoundIdParam =
      this.bidRoundId && this.bidRoundId.trim() !== ""
        ? this.bidRoundId.trim()
        : undefined;

    this.walletService
      .getTokenDetails(this.userId.toString(), bidRoundIdParam)
      .subscribe({
        next: (data: TokenDetail[]) => {
          this.tokenDetails = data;
          this.tokenDetailsLoading = false;
        },
        error: (err: any) => {
          this.tokenDetailsError = "Could not load token details.";
          this.tokenDetailsLoading = false;
        },
      });
  }

  getTokenContracts(): void {
    if (this.userId === null) return;

    this.tokenContractsLoading = true;
    this.tokenContractsError = null;

    const bidRoundIdParam =
      this.bidRoundId && this.bidRoundId.trim() !== ""
        ? this.bidRoundId.trim()
        : undefined;

    this.walletService
      .getTokenContracts(this.userId.toString(), bidRoundIdParam)
      .subscribe({
        next: (data: TokenContractAssignment[]) => {
          this.tokenContracts = data;
          this.tokenContractsLoading = false;
        },
        error: (err: any) => {
          this.tokenContractsError = "Could not load token contracts.";
          this.tokenContractsLoading = false;
        },
      });
  }

  getContractsByType(type: string): TokenContractAssignment[] {
    if (!this.tokenContracts) {
      return [];
    }
    return this.tokenContracts.filter((contract) => contract.type === type);
  }

  getTokenDetailsByChargeType(chargeType: string): TokenDetail[] {
    if (!this.tokenDetails) {
      return [];
    }
    return this.tokenDetails.filter(
      (detail) => detail.charge_type === chargeType
    );
  }

  closeDialog(): void {
    this.dialogRef.close(); // Method to close the dialog
  }
}
